
import { createRoot } from 'react-dom/client';

export default class DocumentContainer {

    private static documentRootCreated = false;
    public static documentContainerRoot;

    public static createDocumentContainer = (container) => {

        if (!DocumentContainer.documentRootCreated) {
            DocumentContainer.documentContainerRoot = createRoot(container);
            DocumentContainer.documentRootCreated = true;
        }

        return DocumentContainer.documentContainerRoot;
    }

}